// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/uScope/js/extensions/annotations/color-picker/color-picker-control.scss
// module id = 359
// module chunks = 0